export const httpErrorHandler = ({
    err,            // The error object from the HTTP response (error.response or error)
    errorKeys,      // Array of keys to look for in the error response
    setFieldErrors, // Object with functions to set field-specific errors
    setSnackbar,    // Function to show snackbar notification
    onCustomError,  // Optional custom error handling function
    navigate,
    setRequestError
}) => {


    // Call the custom error handling function if provided
    onCustomError?.();

    const errorResponse = err.response || err;
    const status = errorResponse?.status;
    const errorData = errorResponse?.data;

    // Extract error message
    let errorMessage = errorData?.message || errorData?.detail || 'حطایی نامشخص رخ داده است';
    const cleanErrorMessage = errorMessage?.replace?.(/\[.*?\]/g, '')?.trim() || errorMessage;

    setRequestError?.(cleanErrorMessage)
    // Show snackbar notification for non-400 errors
    if (setSnackbar) {
        setSnackbar({ message: cleanErrorMessage, type: "error" });
    }

    // Define different error cases and their corresponding handlers
    const errorCases = {
        400: () => handleBadRequest(errorData, errorKeys, setFieldErrors, setSnackbar),  // Handle validation errors
        401: () => navigate ? handleUnauthorized(navigate) : '',                                       // Handle unauthorized errors
        403: () => setSnackbar?.({ message: 'دسترسی رد شد', type: "error" }),           // Handle forbidden errors
        404: () => setSnackbar?.({ message: 'منبع درخواستی یافت نشد', type: "error" }),  // Handle not found errors
        429: () => setSnackbar?.({ message: 'تعداد درخواست‌ها بیش از حد مجاز است. لطفاً کمی بعد دوباره تلاش کنید.', type: "error" }), // Handle too many requests
        500: () => setSnackbar?.({ message: 'مشکلی در سرور رخ داده است. لطفاً کمی بعد دوباره تلاش کنید.', type: "error" }),         // Handle server errors
        default: () => setSnackbar?.({ message: cleanErrorMessage, type: "error" }),     // Handle other errors
    };

    // Determine the error handler based on the error status or use the default handler
    const handler = errorCases[status] || errorCases.default;
    // Execute the determined error handler
    handler?.();
};

// Function to handle bad request errors (400)
const handleBadRequest = (errorData, errorKeys, setFieldErrors, setSnackbar) => {
    // If errorKeys are specified, set field-specific errors
    if (errorKeys && setFieldErrors) {
        let hasFieldErrors = false;

        errorKeys?.forEach(key => {
            const fieldError = errorData?.[key];
            const errorMsg = Array.isArray(fieldError) ? fieldError[0] : fieldError;

            if (errorMsg && setFieldErrors[key]) {
                setFieldErrors[key](errorMsg);
                hasFieldErrors = true;
            }
        });


        // If no field errors found, show general error message
        if (!hasFieldErrors && setSnackbar) {
            const message = errorData?.message || errorData?.detail || 'خطا: درخواست نامعتبر است';
            setSnackbar({ message, type: "error" });
        }
    }
};

// Function to handle unauthorized errors (401)
const handleUnauthorized = (navigate) => {

    // Clear any stored authentication data
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');

    // Redirect to login after a short delay
    setTimeout(() => {
        const currentPath = window.location.pathname;

        if (!currentPath.includes('/login')) {
            navigate('/login');
        }

    }, 1500);
};